
  function initIndexHeroBannerSlider(root = document) {
    if (typeof window.Swiper !== 'function') return;

    const sliders = root.querySelectorAll('[data-index-hero-banner-slider]');

    sliders.forEach((slider) => {
      if (slider.swiper) return;

      new window.Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        autoHeight: true
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIndexHeroBannerSlider(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initIndexHeroBannerSlider(event.target);
  });
